// Search-engine hints for the singles hub.
// Deck-builder links (/collections/singles?build= / ?deck= / ?list= / ?c= / ?card= / ?paste=) are
// app states, not pages: every one canonicalises to /collections/singles and Bing flagged "many
// pages pointing to the same canonical". Mark those states noindex (links still followed). The
// plain /collections/singles page and every other URL are left untouched.

const APP_STATE_PARAMS = ['build', 'deck', 'list', 'c', 'card', 'paste'];

export function isAppStateUrl(pathname, search) {
  if (!/^\/collections\/singles\/?$/.test(pathname || '')) return false;
  const sp = new URLSearchParams(search || '');
  return APP_STATE_PARAMS.some((k) => sp.has(k));
}

export function applyRobots(doc = document, loc = location) {
  if (!isAppStateUrl(loc.pathname, loc.search)) return false;
  let m = doc.querySelector('meta[name="robots"]');
  if (!m) {
    m = doc.createElement('meta');
    m.setAttribute('name', 'robots');
    doc.head.appendChild(m);
  }
  m.setAttribute('content', 'noindex, follow');
  return true;
}
